import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';

// A document is a "paper" artifact: it uses fixed neutral colors instead of semantic theme
// tokens so the preview and the captured PDF look identical in light and dark mode.
const Paper = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="bg-white px-12 py-10 flex flex-col gap-8">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Paper;